import React from 'react';
import { useNavigate } from 'react-router';
import { strings } from '/imports/strings';
import { useUser } from '/imports/hooks';
import { Icon } from '/imports/ui/Icon';


export const NotFoundPage = () => {
  const user = useUser();
  const navigate = useNavigate();
  if (!user) navigate('/login');
  return (
    <div className="page flex h-full w-full flex-col justify-around text-center [&_p]:text-center [&_p]:text-[1.1rem]">
      <div className="wrapper m-auto">
        <Icon icon="warning" />
        <h2>{strings.NotFound()}</h2>
      </div>
    </div>
  );
};